import { render } from "./tb.vue?vue&type=template&id=1e6a7c38&scoped=true"
import script from "./tb.vue?vue&type=script&lang=js"
export * from "./tb.vue?vue&type=script&lang=js"

import "./tb.vue?vue&type=style&index=0&id=1e6a7c38&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e6a7c38"]])

export default __exports__